var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHomeChargingMedium(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.5351562,17.1210938L26.4140625,1C25.125-0.2890625,22.875-0.2890625,21.5859375,1L5.4648438,17.1210938 C4.5205078,18.0654297,4,19.3212891,4,20.6572266V43c0,1.6542969,1.3457031,3,3,3h34c1.6542969,0,3-1.3457031,3-3V20.6572266 C44,19.3212891,43.4794922,18.0654297,42.5351562,17.1210938z M42,43c0,0.5517578-0.4482422,1-1,1H25v-8h6 c1.6542969,0,3-1.3457031,3-3V23c0-1.6542969-1.3457031-3-3-3h-1v-8h-2v8h-8v-8h-2v8h-1c-1.6542969,0-3,1.3457031-3,3v10 c0,1.6542969,1.3457031,3,3,3h6v8H7c-0.5517578,0-1-0.4482422-1-1V20.6572266c0-0.8017578,0.3124862-1.5556641,0.8789062-2.1220703 L23,2.4140625C23.2675781,2.1474609,23.6220703,2,24,2s0.7324219,0.1474609,1,0.4140625l16.1210938,16.1210938 C41.6874847,19.1015625,42,19.8554688,42,20.6572266V43z M31,22c0.5517578,0,1,0.4482422,1,1v10c0,0.5517578-0.4482422,1-1,1H17 c-0.5517578,0-1-0.4482422-1-1V23c0-0.5517578,0.4482422-1,1-1H31z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeChargingMedium);
export default __webpack_public_path__ + "static/media/home-charging--medium.693c0aaeaf620001af1d1bde25b6a5a2.svg";
export { ForwardRef as ReactComponent };